/* eslint-disable i18next/no-literal-string */
import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import { Controller, useFormContext } from 'react-hook-form';
import { FormInput } from 'app/components/Common/Form/FormInput';
import { IExceptionWaive, IRequirementType } from './models/PlacementDialogModels';
import { CredentialsSearch } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/CredentialsTab/Search/CredentialsSearch';
import { useSelector } from 'react-redux';
import { ExceptionWaiveSelection } from '../../../Store/PlacementEventDetails.selector';
import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';

const useStyles = makeStyles()({
  container: {
    display: 'flex',
  },
  header: {
    fontSize: '12px',
    color: '#555555',
    paddingBottom: '10px',
    fontWeight: 500,
  },
});

interface ICredentialAndStatus {
  credentialName?: string;
  type: IRequirementType;
  data: IExceptionWaive;
  isChanged: (name: string, value: string) => void;
}

export const CredentialAndStatus = ({ credentialName, type, isChanged }: ICredentialAndStatus) => {
  const { classes } = useStyles();
  const exceptionWaiveSel = useSelector(ExceptionWaiveSelection);
  const { control, setValue } = useFormContext();
  const [searchInput, setSearchInput] = useState<string>('');

  useEffect(() => {
    if (exceptionWaiveSel) {
      setValue('type', exceptionWaiveSel.type);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSelect = option => {
    setSearchInput(option.selectedTitle);
    setValue('requirementName', option.category);
    setValue('requirementTypeID', option.requirementTypeID);
  };

  const onSearchInputChange = value => {
    if (value === '') setValue('requirementName', null);
    setSearchInput(value);
  };

  return (
    <LayoutGrid wrap={'nowrap'} spacing={2} className={classes.container}>
      <LayoutGridItem style={{ width: '25%' }}>
        {type === IRequirementType.markException ? (
          <FormInput label="Credential Name" customClasses={classes.header}>
            <Typography variant="body1">{credentialName}</Typography>
          </FormInput>
        ) : (
          <>
            <FormInput label="Requirement Name*" customClasses={'labelDialog'}>
              <Controller
                control={control}
                name={'requirementName'}
                render={({ field: { onChange, ...rest } }) => (
                  <CredentialsSearch
                    {...rest}
                    onAddSearch
                    includeTypes={false}
                    searchInput={searchInput}
                    onSelect={onSelect}
                    onSearchInputChange={onSearchInputChange}
                  />
                )}
              />
            </FormInput>
            <FormInput label={''}>
              <Controller
                control={control}
                name={'requirementTypeID'}
                render={({ field: { onChange, ...rest } }) => <input type="hidden" defaultValue={''} {...rest} />}
              />
            </FormInput>
          </>
        )}
      </LayoutGridItem>
      <LayoutGridItem style={{ width: '25%' }}>
        <FormInputDropdown
          name={'type'}
          label={`Status*`}
          require={true}
          options={[
            { ID: 'Exception', Description: 'Exception' },
            { ID: 'Waive', Description: 'Waive' },
          ]}
          handleChange={e => {
            isChanged('type', e.target.value);
            setValue('type', e.target.value, { shouldDirty: true });
          }}
        ></FormInputDropdown>
      </LayoutGridItem>
    </LayoutGrid>
  );
};
